import styled from "styled-components";

export const MessageStyles = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 8px;
  margin-top: ${({ $isFirst }) => ($isFirst ? "8px" : "2px")};
  margin-bottom: ${({ $isLast }) => ($isLast ? "4px" : "0")};
  justify-content: ${({ $isMyMessage }) =>
    $isMyMessage ? "flex-end" : "flex-start"};

  .avatarSlot {
    width: 28px;
    flex-shrink: 0;
    align-self: flex-end;
  }

  .avatar {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: ${({ theme }) => theme.colors.accent[100]};
    color: ${({ theme }) => theme.colors.accent[500]};
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 12px;
  }

  .bubbleColumn {
    display: flex;
    flex-direction: column;
    gap: 4px;
    max-width: 78%;
    min-width: 0;
    align-items: ${({ $isMyMessage }) =>
      $isMyMessage ? "flex-end" : "flex-start"};
  }

  .bubble {
    display: inline-block;
    max-width: 100%;
    padding: 10px 14px;
    font-size: 14px;
    line-height: 20px;
    font-weight: 500;
    word-wrap: break-word;
    overflow-wrap: anywhere;
    background: ${({ $isMyMessage, theme }) =>
      $isMyMessage ? theme.colors.accent[400] : theme.colors.accent[50]};
    color: ${({ $isMyMessage, theme }) =>
      $isMyMessage ? theme.colors.semantic.accent.onAccent : theme.colors.semantic.text.strong};
    border-radius: ${({ $isMyMessage, $isFirst, $isLast }) => {
      if ($isMyMessage) {
        const topRight = $isFirst ? "16px" : "4px";
        const bottomRight = $isLast ? "4px" : "16px";
        return `16px ${topRight} ${bottomRight} 16px`;
      }
      const topLeft = $isFirst ? "16px" : "4px";
      const bottomLeft = $isLast ? "4px" : "16px";
      return `${topLeft} 16px 16px ${bottomLeft}`;
    }};
  }

  .time {
    font-size: 11px;
    color: ${({ theme }) => theme.colors.semantic.text.weak};
    padding: 0 4px;
  }
`;
